<template>
  <div
      class="setting-field"
      :class="{'disable-html-component': missing}">
    <el-badge
        value="error"
        class="label"
        :hidden="!missing">
      <label> {{ label }} </label>
    </el-badge>
    <el-input
        v-model="value"
        size="small"
        :disabled="!isAdmin"
        @change="onChange" />
    <span
        v-show="error"
        class="update-setting_error_msg">{{ message }}</span>
  </div>
</template>

<script>
import { isEmpty, isNil, every, has, set, get, startCase } from "lodash";

export default {
  name: "InputTextSetting",
  props: {
    config: {
      type: Object,
      required: true,
      validator: function (object) {
        return (
          every(["label", "value", "path", "input"], (k) => has(object, k)) &&
          ["server_domain", "server_port", "server_ip", "free_text"].includes(
            object.input.type
          )
        );
      },
    },
  },
  data() {
    return {
      regexps: {
        server_domain:
          /^(([_a-zA-Z0-9]|[_a-zA-Z0-9][_a-zA-Z0-9\-]*[_a-zA-Z0-9])\.)*([_A-Za-z0-9]|[_A-Za-z0-9][_A-Za-z0-9\-]*[_A-Za-z0-9])$/,
        server_port:
          /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
        server_ip:
          /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/,
      },
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    label() {
      return this.config.label;
    },
    path() {
      return this.config.path;
    },
    missing() {
      return false;
    },
    show() {
      return !get(this, "config.removed", false);
    },
    pattern() {
      return this.regexps[this.config.input.type] || /.*/;
    },
    message() {
      return (
        this.config.input.message ||
        "Invalid " + startCase(this.config.input.type)
      );
    },
    valid() {
      return isEmpty(this.config.value) || this.pattern.test(this.config.value);
    },
    error() {
      return !this.valid;
    },
    value: {
      get() {
        let v = this.config.value;
        return isNil(v) ? "" : v;
      },
      set(v) {
        this.config.value = v;
      },
    },
  },
  methods: {
    parseValue(val) {
      val = val.trim();
      const isPort = this.config.input.type === "server_port";
      if (isPort && !isEmpty(val)) return Number(val);
      else return val;
    },
    onChange(val) {
      if (this.valid === false) return;
      const payload = set({}, this.path, this.parseValue(val));
      this.$emit("change", { payload, done: () => {} });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "settings";
@include settingField();
.update-setting_error_msg {
  color: $--color-milano-red;
  font-size: smaller;
}
</style>
